import { LOG_VIEW } from '../../config';
import { getActions } from '../../services/index.service';
import { LogView } from '../../views/index.view';
import store from '../../redux/store';

export default function route() {
  const state = store.getState();
  let userType = state?.auth?.userData?.Role?.type ?? '';

  return [
    (LOG_VIEW === 'on' && userType !== 'nca')&& {
      path: accessRoute.LOGS.path,
      private: true,
      name: accessRoute.LOGS.name,
      key: accessRoute.LOGS.key,
      belongsToSidebar: LOG_VIEW === 'on',
      icon: accessRoute.LOGS.icon,
      element: <LogView />,
      ...accessRoute.LOGS,
    },
  ];
}

export const accessRoute = {
  LOGS: {
    path: '/admin/logs',
    action: getActions('LIST').value,
    name: 'Log Viewer',
    key: 'logs',
    ignorePermission: true,
    icon: (
      <span className="nk-menu-icon">
        <em className="icon ni ni-grid-alt-fill" />
      </span>
    ),
  },
};

export const getChildrenRoutes = () => {
  return route();
};
